import { render, staticRenderFns } from "./Debate.vue?vue&type=template&id=489d8997&scoped=true&"
import script from "./Debate.vue?vue&type=script&lang=js&"
export * from "./Debate.vue?vue&type=script&lang=js&"
import style0 from "./Debate.vue?vue&type=style&index=0&id=489d8997&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489d8997",
  null
  
)

export default component.exports